<template>
  <v-card>
    <div class="d-flex justify-space-between align-center">
      <p class="ma-0 pl-2 pt-4 pb-1">Reporte de movimiento por usuario</p>
    </div>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-text-field
            :value="datesSelected.join(' ~ ')"
            label="Filtro por fecha"
            outlined
            @click="showCalendar = true"
            hide-details
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="6" xl="6">
          <v-select
            :items="branchs"
            v-model="branchSelected"
            outlined
            hide-details
            item-value="value"
            item-text="title"
            label="Filtro por sucursal"
            @change="searchByDates"
          ></v-select>
        </v-col>

        <v-col
          cols="12"
          class="d-flex justify-center text-center mt-4"
          v-if="loadingAverage"
        >
          <v-progress-circular
            indeterminate
            size="50"
            color="primary"
          ></v-progress-circular>
        </v-col>
        <v-col cols="12" v-else>
          <v-data-table
            :headers="headers"
            :items="userData"
            :items-per-page="20"
            class="elevation-0"
          >
          </v-data-table>
          <div class="text-center">
            <v-btn color="primary" @click="exportData">
              Exportar datos
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="showCalendar" max-width="300" persistent>
      <v-card>
        <v-container>
          <v-date-picker
            v-model="datesSelected"
            multiple
            :disabled="datesSelected.length > 1"
          ></v-date-picker>
          <div class="d-flex justify-space-between mt-3">
            <v-btn
              color="primary"
              :disabled="datesSelected.length < 2"
              @click="searchByDates"
              >Aceptar</v-btn
            >
            <v-btn @click="clearDates">Limpiar</v-btn>
          </div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";
import { json2excel } from "js2excel";

export default {
  data() {
    return {
      loadingAverage: false,

      showCalendar: false,
      datesSelected: [
        moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        moment()
          .endOf("month")
          .format("YYYY-MM-DD")
      ],
      headers: [
        {
          text: "Usuario",
          value: "name",
          width: "200px"
        },
        { text: "Sucursal", value: "branch", width: "100px" },
        { text: "Ultimo acceso", value: "access", width: "150px" },
        { text: "Entregas", value: "entregas", width: "100px" },
        { text: "Recolecciones", value: "recoleccion", width: "120px" },
        { text: "Reubicaciones", value: "reubicacion", width: "120px" },
        { text: "Mantenimiento", value: "mantenimiento", width: "120px" },
        { text: "Rentado servicio", value: "rentado", width: "130px" },
        { text: "Total de movimientos", value: "total", width: "150px" }
      ],
      userData: [],
      branchSelected: 1
    };
  },
  computed: {
    ...mapState("user", ["data"]),
    ...mapState("checklist", ["branchs"])
  },
  async mounted() {
    this.getUserData();
    this.getBranch();
  },
  methods: {
    ...mapActions("checklist", ["getUsageUserAnalytics", "getBranch"]),
    async getUserData() {
      try {
        this.loadingAverage = true;
        const responseData = await this.getUsageUserAnalytics({
          startAt:
            this.datesSelected[0] < this.datesSelected[1]
              ? this.datesSelected[0]
              : this.datesSelected[1],
          endAt:
            this.datesSelected[1] > this.datesSelected[0]
              ? this.datesSelected[1]
              : this.datesSelected[0],
          branch: this.branchSelected
        });
        this.userData.splice(0, this.userData.length);
        for (const user of responseData) {
          this.userData.push(user);
        }
        this.sortData("total", -1, 1);
        this.loadingAverage = false;
      } catch (error) {
        this.loadingAverage = false;
      }
    },
    searchByDates() {
      this.getUserData();
      this.showCalendar = false;
    },
    sortData(keySort, orderOne, orderTwo) {
      this.userData.sort((a, b) => {
        if (a[keySort] > b[keySort]) {
          return orderOne;
        }
        if (a[keySort] < b[keySort]) {
          return orderTwo;
        }
        return 0;
      });
    },
    clearDates() {
      this.datesSelected.splice(0, this.datesSelected.length);
    },
    exportData() {
      try {
        json2excel({
          data: this.userData,
          name: `user-report-${moment().format("YYYY-MM-DD")}`,
          formateDate: "yyyy/mm/dd"
        });
      } catch (e) {
        console.error("export error");
      }
    }
  }
};
</script>

<style>
.text-analytics {
  font-size: 70px !important;
}
.v-data-table {
  overflow-x: auto !important;
}
</style>
